<template>
        <div class="route1" v-if="bindData">
            <div :class="{active:j==isActive}" class="route_one" @click="sendMsg(v,j)" v-for="(v,j) in bindData" >{{v.name}}

            </div>

        </div>
</template>

<script>
    export default {
        name: "route",
        data() {
            return {
                isActive:0
            }
        },
        created() {
        },
        props:{
            bindData:{
                type:Array,
                default:function (value) {
                    return value
                }
            }
        },
        components: {
        },
        methods: {
            sendMsg(v,j){
                this.$emit("transfer",v.url);
                this.isActive = j;
            }
        },
    }

</script>

<style lang="less" scoped>
    .active{
                background-color:rgb(155, 155, 155) !important;
                height: 40px;
                line-height: 40px;
                font-size:14px;
                color: black;
                width: 170px;
                text-align: center;
                position: relative;
                border-left: 1px solid rgba(204, 204, 204, 1)!important;
    }
        .route1{
            display: flex;
            height: 40px;
            width: 1200px;
            margin: 0 auto;
            align-items: center;
            margin-top: 20px;

            .route_one{
                background-color: rgb(243,244,248);
                height: 40px;
                line-height: 40px;
                font-size:14px;
                color: black;
                width: 170px;
                text-align: center;
                position: relative;
                border-left: 1px solid rgba(204, 204, 204, 1);

            }
            .route_one:hover{
                background: rgb(204,204,204);
            }
            :last-child{
                border-right:1px solid rgba(204, 204, 204, 1);
            }
        }



</style>
